import { render, staticRenderFns } from "./item_base.vue?vue&type=template&id=0a5a2fd0"
import script from "./item_base.vue?vue&type=script&lang=js"
export * from "./item_base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports